<script setup>
// Placeholder — Preferences tab. Future: default deck, audio playback rate,
// auto-advance, voice-recognition aggressiveness, etc.
</script>

<template>
  <div class="card border-0 shadow-sm">
    <div class="card-body">
      <h2 class="h5 mb-3"><i class="bi bi-sliders me-2"></i>Preferences</h2>
      <p class="text-muted mb-0">
        Per-user preferences — default deck, playback rate, auto-advance,
        and other quiz options — will live here.
      </p>
    </div>
  </div>
</template>
